module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/seat-relocate/seat-relocate.component.scss
// module id = ./src/app/modules/backstage-module/components/seat-relocate/seat-relocate.component.scss
// module chunks = 9